import { handleError } from '@signal24/vue-foundation';
import { watch } from 'vue';
import { GlobalState } from './global';
import { SSECoreReconfigureChannel } from './modules/core/sse';
import { CoreConfigApi } from './openapi-clients-generated/suite';

export function useTenantConfiguration() {
    const loadTenantConfiguration = async () => {
        if (!GlobalState.tenant.value || !GlobalState.user.value) {
            GlobalState.tenantConfiguration.value = null;
            return;
        }

        try {
            const response = await CoreConfigApi.getCoreConfigGetCommonConfig();
            GlobalState.tenantConfiguration.value = response.data ?? null;
        } catch (error) {
            handleError('Failed to load tenant configuration:', error);
            GlobalState.tenantConfiguration.value = null;
        }
    };

    SSECoreReconfigureChannel.use(loadTenantConfiguration);

    watch(
        GlobalState.tenant,
        () => {
            loadTenantConfiguration();
        },
        { immediate: true }
    );
}
